import React, { ReactNode } from "react";
import styles from "./ResponseMessage.module.css";
import classNames from "classnames";
import {
  IResponseMessageUI,
  MessageType,
} from "../../../lib/store/reducers/responseMessagesReducer";
import { getParamValue } from "../../../utils/UtilMethods";

export const GlobalMessageList = ({ children, className }: { children: ReactNode, className?: string }) => {
  return <ul className={className || styles["global-message-list"]}>{children}</ul>;
};

interface GlobalMessageItemProps {
  message: IResponseMessageUI;
  isPendingRemoval: boolean;
  onAnimationEnd: () => void;
  onConfirm: () => void;
}
const ws = getParamValue("ws");

export const GlobalMessageItem = ({
  message,
  isPendingRemoval,
  onAnimationEnd,
  onConfirm,
}: GlobalMessageItemProps) => {
  const handleClick = () => {
    onConfirm();
  };

  const notificationLevelClass = () => {
        if (message.messageType === MessageType.WAREHOUSE) {
      if (ws == 7207) {
        return styles["toast--PharmacistMsg"]
       ;
      }
       return styles["toast--error"];
    }
    if (message.messageType === MessageType.ERROR) return styles[`toast--error`];
    if (message.messageType === MessageType.SUCCESS) return styles[`toast--success`];
    if (message.messageType === MessageType.WARNING) return styles[`toast--warning`];

    return styles[`toast--notification`];
  };
    const classes = classNames(styles["toast-container"], notificationLevelClass(), styles["open"], {
    [styles["closed"]]: isPendingRemoval,
});
  return (
    <li
        className={classes}
      role="status"
      aria-live="off"
      aria-atomic="true"
      onAnimationEnd={() => {
        if (isPendingRemoval) onAnimationEnd();
      }}
    >
      <div className={styles["toast-content"]}>
        <div className={styles["toast-info"]}>
          {message.messageType === MessageType.WAREHOUSE ? (
            <div className={styles["toast-text"]}>
              <strong>{ws == 7207 ?  "Farmaceut meddelande: " : message.title + ": " } </strong> {message.content}
            </div>
          ) : (
            <>
              <div className={styles["toast-title"]}>{message.title}</div>
              <div className={styles["toast-text"]}>{message.content}</div>
            </>
          )}
          <div className={styles["toast-time"]}>{message.createdAt}</div>
        </div>
        <button
          type="button"
          className={styles["toast-close"]}
          aria-label="Stäng"
          onClick={handleClick}
          style={{ color: message.messageType === MessageType.WAREHOUSE ? "white" : "inherit" }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          >
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>
      </div>
    </li>
  );
};
export default GlobalMessageList;